(function () {

  'use strict';

  function filterService() {

    // filterList is converting the filterObject(s) to be compatible with GET or POST
    // ------------------
    // prepareParameterList() a list of parameters is mapped from the filterObject
    // removeDuplicatesParameterList() the parameterList is sanitized and duplicates are removed
    // createParametersObject() is pairing parameterList with the values of the filterObject. It differentiate between: filterObject.type & requestType
    // convertParameterValuesToString() if requestType is GET
    function filterList(filterObject, requestType) {
      let parameterList = prepareParameterList(filterObject);
      parameterList = removeDuplicatesParameterList(parameterList);
      parameterList = createParametersObject(filterObject, parameterList, requestType);
      return convertParameterValuesToString(parameterList, requestType);
    }

    function prepareParameterList(filterObject) { // TODO CLEAN THIS UP AND SPLIT INTO SMALLER FUNCTIONS
      const parameterList = [];
      for (let i = 0; i < filterObject.length; i++) {
        if (filterObject[i].type === 'range' || filterObject[i].type === 'range-input' || filterObject[i].type === 'range-date') {
          for (let j = 0; j < filterObject[i].keys.length; j++) {
            parameterList.push(filterObject[i].keys[j].key);
          }
        } else {
          parameterList.push(filterObject[i].parameter);
        }
      }
      return parameterList;
    }

    function removeDuplicatesParameterList(parameterList) {
      return parameterList.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });
    }

    function createParametersObject(filterObject, parameterList, requestType) { // TODO CLEAN THIS UP AND SPLIT INTO SMALLER FUNCTIONS
      const parametersObject = {};
      for (let i = 0; i < parameterList.length; i++) {
        let values = [];
        for (let j = 0; j < filterObject.length; j++) {
          if (filterObject[j].type === 'range' || filterObject[j].type === 'range-input' || filterObject[j].type === 'range-date') {
            for (let k = 0; k < filterObject[j].keys.length; k++) {
              if (parameterList[i] === filterObject[j].keys[k].key && requestType === 'GET') {
                values.push(filterObject[j].keys[k].count);
              } else if (parameterList[i] === filterObject[j].keys[k].key) {
                values = filterObject[j].keys[k].count;
              }
            }
          } else if (filterObject[j].type === 'radio') {
            if (parameterList[i] === filterObject[j].parameter) {
              values = filterObject[j].state;
            }
          } else if (parameterList[i] === filterObject[j].parameter) {
            values.push(filterObject[j].key);
          }
        }
        parametersObject[parameterList[i]] = values;
      }
      return parametersObject;
    }

    function convertParameterValuesToString(parameterList, requestType) {
      if (requestType === 'GET') {
        for (const key in parameterList) {
          if (parameterList[key] && Array.isArray(parameterList[key])) {
            parameterList[key] = parameterList[key].toString();
          }
        }
      }

      return parameterList;
    }

    return {
      filterList: filterList
    };
  }

  filterService.$inject = [];

  angular
    .module('printix-admin')
    .service('FilterService', filterService);

})();
